export const formatCardNumber = (cardNumber: string) => {
  return cardNumber.slice(-9).replace('-', ' ').replace(/X/g, '*');
};
